import { Storage } from '@/firebase/index';

export default {
  async getTermsAttachments(storage = 'InvestmentTerms') {
    const storageEnvironment = Storage.ref(storage);

    const response = await storageEnvironment.listAll();

    return response;
  },

  async urlAttachment(file, storage = 'InvestmentTerms') {
    var urlAtt = '';
    const storageEnvironment = Storage.ref(storage);
    await storageEnvironment
      .child(file)
      .getDownloadURL()
      .then(function(url) {
        urlAtt = url;
      });

    return urlAtt;
  }
};
